import React, { useState } from 'react';
import { HiSearch, HiBell, HiUser, HiMenu, HiX } from 'react-icons/hi';
import './TopBar.css';

const TopBar = ({ activeChannel, onChannelSelect, channels, userName }) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleMobileNavClick = (channelId) => {
    onChannelSelect(channelId);
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="top-bar">
      <div className="top-bar-left">
        <div className="logo-section">
          <img src="/eddie-logo.svg" alt="Eddie TV" className="logo-image" />
        </div>
        <button
          className="mobile-menu-btn"
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <HiX /> : <HiMenu />}
        </button>
        <nav className={`main-nav ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <ul className="nav-list">
            {channels.map(channel => (
              <li key={channel.id}>
                <button
                  className={`nav-link ${activeChannel === channel.id ? 'active' : ''}`}
                  onClick={() => handleMobileNavClick(channel.id)}
                >
                  {channel.name}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="top-bar-right">
        <div className={`search-container ${isSearchOpen ? 'expanded' : ''}`}>
          {isSearchOpen ? (
            <>
              <HiSearch className="search-icon" />
              <input
                type="search"
                className="search-input"
                placeholder="Titels, personen, genres"
                aria-label="Zoeken"
                autoFocus
                onBlur={() => setIsSearchOpen(false)}
              />
            </>
          ) : (
            <button
              className="icon-btn"
              aria-label="Zoeken"
              onClick={() => setIsSearchOpen(true)}
            >
              <HiSearch />
            </button>
          )}
        </div>
        <button className="icon-btn" aria-label="Notificaties">
          <HiBell />
        </button>
        <div className="user-menu">
          <button className="icon-btn profile-btn" aria-label="Gebruikersprofiel">
            <HiUser />
          </button>
          <span className="user-greeting">Hi, {userName}</span>
        </div>
      </div>
    </header>
  );
};

export default TopBar;
